module.exports = __webpack_public_path__ + "img/mob-uparrow.b2e460c8.svg";